import { render, staticRenderFns } from "./MiniSmoothArea.vue?vue&type=template&id=608afc5c&scoped=true"
import script from "./MiniSmoothArea.vue?vue&type=script&lang=js"
export * from "./MiniSmoothArea.vue?vue&type=script&lang=js"
import style0 from "./MiniSmoothArea.vue?vue&type=style&index=0&id=608afc5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608afc5c",
  null
  
)

export default component.exports